import type { PropsWithChildren, ReactElement } from 'react'
import { inputGroup } from '~/components/Form/Form.css'
import { Label } from '~/components/Form/Input/Label'
import { InputLine, type InputLineJustify } from './InputLine'

export const InputGroup = ({
  children,
  label,
  justify,
  align = 'center',
  fluid = false
}: PropsWithChildren<{
  label: string
  align?: 'start' | 'center'
  justify?: InputLineJustify
  fluid?: boolean
}>): ReactElement => {
  return (
    <div className={inputGroup}>
      <Label>{label}</Label>
      <InputLine align={align} justify={justify} fluid={fluid}>
        {children}
      </InputLine>
    </div>
  )
}
